import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../shared/modules/material.module';
import { DxAutocompleteModule, DxButtonModule, DxChartModule, DxColorBoxModule, DxDataGridModule, DxGanttModule, DxLinearGaugeModule, DxLoadPanelModule, DxPieChartModule, DxPopupModule, DxSchedulerModule, DxSliderModule, DxTemplateModule, DxTextBoxModule } from 'devextreme-angular';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

// import { CreateModalComponent } from '../layouts/admin-layout/fragments/create-modal/create-modal.component';
import { ExternalRequestModalComponent } from '../shared/components/external-request/external-request-modal/external-request-modal.component';
import { ExternalRequestService } from '../shared/components/external-request/external-request.service';
import { AccountComponent } from './account-page/account/account.component';
import { PasswordModalComponent } from './account-page/account/password-modal/password-modal.component';
import { AgentsModalComponent } from './agents-page/agents/agents-modal/agents-modal.component';
import { AgentsComponent } from './agents-page/agents/agents.component';
import { AgentsService } from './agents-page/agents/agents.service';
import { BillingDocumentsBulkModalComponent } from './billing-documents-page/billing-documents/billing-documents-bulk-modal/billing-documents-bulk-modal.component';
import { BillingDocumentsModalComponent } from './billing-documents-page/billing-documents/billing-documents-modal/billing-documents-modal.component';
import { BillingDocumentsPDFModalComponent } from './billing-documents-page/billing-documents/billing-documents-pdf-modal/billing-documents-pdf-modal.component';
import { BillingDocumentsComponent } from './billing-documents-page/billing-documents/billing-documents.component';
import { BillingDocumentService } from './billing-documents-page/billing-documents/billing-documents.service';
import { CorrectiveInvoiceModalComponent } from './billing-documents-page/billing-documents/corrective-invoice-modal/corrective-invoice-modal.component';
import { CorrectiveInvoiceService } from './billing-documents-page/billing-documents/corrective-invoice-modal/corrective-invoice.service';
import { CategoriesModalComponent } from './categories-page/categories/categories-modal/categories-modal.component';
import { CategoriesComponent } from './categories-page/categories/categories.component';
import { CategoriesService } from './categories-page/categories/categories.service';
import { ClientsModalComponent } from './clients-page/clients/clients-modal/clients-modal.component';
import { ClientsComponent } from './clients-page/clients/clients.component';
import { ClientsService } from './clients-page/clients/clients.service';
import { CompaniesModalComponent } from './companies-page/companies/companies-modal/companies-modal.component';
import { CompaniesStatsComponent } from './companies-page/companies/companies-stats/companies-stats.component';
import { CompaniesComponent } from './companies-page/companies/companies.component';
import { CompaniesService } from './companies-page/companies/companies.service';
import { CountersModalComponent } from './counters-page/counters/counter-modal/counters-modal.component';
import { CountersService } from './counters-page/counters/counters.service';
import { CountriesModalComponent } from './countries-page/countries/countries-modal_out/countries-modal.component';
import { CountriesComponent } from './countries-page/countries/countries.component';
import { CountriesService } from './countries-page/countries/countries.service';
import { CurrenciesModalComponent } from './currencies-page/currencies/currencies-modal/currencies-modal.component';
import { CurrenciesComponent } from './currencies-page/currencies/currencies.component';
import { CurrenciesService } from './currencies-page/currencies/currencies.service';
import { DetailItemExpensesComponent } from './expenses-page/expenses/detail-item-expenses/detail-item-expenses.component';
import { DetailListExpensesComponent } from './expenses-page/expenses/detail-list-expenses/detail-list-expenses.component';
import { ExpensesModalComponent } from './expenses-page/expenses/expenses-modal/expenses-modal.component';
import { ExpensesComponent } from './expenses-page/expenses/expenses.component';
import { ExpensesService } from './expenses-page/expenses/expenses.service';
import { FeaturesModalComponent } from './features-page/features/features-modal/features-modal.component';
import { FeaturesComponent } from './features-page/features/features.component';
import { FeaturesService } from './features-page/features/features.service';
import { ChangeLogComponent } from './logger-page/logger/change-log/change-log.component';
import { LoggerComponent } from './logger-page/logger/logger.component';
import { LoggerService } from './logger-page/logger/logger.service';
import { ProductsModalComponent } from './products-page/products/products-modal/products-modal.component';
import { ProductsComponent } from './products-page/products/products.component';
import { ProductsService } from './products-page/products/products.service';
import { QuotesHttpService } from './quotes-page/quotes/quotes-http.service';
import { QuotesModalComponent } from './quotes-page/quotes/quotes-modal/quotes-modal.component';
import { QuotesPDFModalComponent } from './quotes-page/quotes/quotes-pdf-modal/quotes-pdf-modal.component';
import { QuotesComponent } from './quotes-page/quotes/quotes.component';
import { QuotesService } from './quotes-page/quotes/quotes.service';
import { RolesModalComponent } from './roles-page/roles/roles-modal/roles-modal.component';
import { RolesComponent } from './roles-page/roles/roles.component';
import { RolesService } from './roles-page/roles/roles.service';
import { AgreementsComponent } from './service-agreements-page/service-agreements/service-agreements.component';
import { ServiceAgreementHttpService } from './service-agreements-page/service-agreements/service-agreements.service';
import { SettingsCompanyModalComponent } from './settings-page/settings/settings-company-modal/settings-company-modal.component';
import { SettingsCompanyComponent } from './settings-page/settings/settings-company/settings-company.component';
import { SettingsModalComponent } from './settings-page/settings/settings-modal/settings-modal.component';
import { SettingsComponent } from './settings-page/settings/settings.component';
import { SettingsService } from './settings-page/settings/settings.service';
import { SubscriptionsModalComponent } from './subscriptions-page/subscriptions/subscriptions-modal/subscriptions-modal.component';
import { SubscriptionsComponent } from './subscriptions-page/subscriptions/subscriptions.component';
import { SubscriptionsService } from './subscriptions-page/subscriptions/subscriptions.service';
import { AppointmentsService } from './tasks-page/tasks/appoinment/appointment.service';
import { MatchClientModalComponent } from './tasks-page/tasks/match-client-modal/match-client-modal.component';
import { NextAppointmentModalComponent } from './tasks-page/tasks/next-appointment-modal/next-appointment-modal.component';
import { TaskBoardComponent } from './tasks-page/tasks/task-board/task-board.component';
import { TaskClientAddressSelComponent } from './tasks-page/tasks/task-client-address-sel/task-client-address-sel.component';
import { TaskCommentComponent } from './tasks-page/tasks/task-comment/task-comment.component';
import { TaskCommentService } from './tasks-page/tasks/task-comment/task-comment.service';
import { TaskCommentsComponent } from './tasks-page/tasks/task-comments/task-comments.component';
import { TaskGroupComponent } from './tasks-page/tasks/task-group/task-group.component';
import { TaskHttpService } from './tasks-page/tasks/task-http.service';
import { TaskListComponent } from './tasks-page/tasks/task-list/task-list.component';
import { TaskModalProductsComponent } from './tasks-page/tasks/task-modal-products/task-modal-products.component';
import { TaskModalComponent } from './tasks-page/tasks/task-modal/task-modal.component';
import { TaskMovementsComponent } from './tasks-page/tasks/task-movements/task-movements.component';
import { TaskScheduleComponent } from './tasks-page/tasks/task-schedule/task-schedule.component';
import { TaskSearchComponent } from './tasks-page/tasks/task-search/task-search.component';
import { TaskShareComponent } from './tasks-page/tasks/task-share/task-share.component';
import { TaskShareService } from './tasks-page/tasks/task-share/task-share.service';
import { TaskSingleComponent } from './tasks-page/tasks/task-single/task-single.component';
import { TaskWorkerWhappSelComponent } from './tasks-page/tasks/task-worker-whapp-sel/task-worker-whapp-sel.component';
import { TaskComponent } from './tasks-page/tasks/task.component';
import { TaskService } from './tasks-page/tasks/task.service';
import { TimeTrackModalComponent } from './time-tracks-page/time-track/time-track-modal/time-track-modal.component';
import { TimeTrackComponent } from './time-tracks-page/time-track/time-track.component';
import { TimeTrackService } from './time-tracks-page/time-track/time-track.service';
import { UsersModalComponent } from './users-page/users/users-modal/users-modal.component';
import { UsersComponent } from './users-page/users/users.component';
import { UserService } from './users-page/users/users.service';
import { WorkersModalComponent } from './workers-page/workers/workers-modal/workers-modal.component';
import { WorkersComponent } from './workers-page/workers/workers.component';
import { WorkersService } from './workers-page/workers/workers.service';
import { TaskRequestsComponent } from './task-requests-page/task-requests/task-requests.component';
import { TaskRequestsDetailComponent } from './task-requests-page/task-requests/task-requests-detail/task-requests-detail.component';
import { DashboardComponent } from './dashboard-page/dashboard/dashboard.component';
import { CalendarComponent } from './calendar-page/calendar/calendar.component';
import { FileUploaderComponent } from '../shared/components/files/file-uploader/file-uploader.component';
import { CalendarByWorkerComponent } from './calendar-page/calendar-old/calendar-by-worker/calendar-by-worker.component';
import { CalendarByClientComponent } from './calendar-page/calendar-old/calendar-by-client/calendar-by-client.component';
import { FileService } from '../shared/components/files/file.service';
import { DeleteTasksDialogComponent } from './calendar-page/calendar-old/delete-tasks-dialog/delete-tasks-dialog.component';
// import { DashboardHttpService } from './dashboard-page/dashboard/dashboard-http.service';
// import { DashBoardService } from './dashboard-page/dashboard/dashboard.service';
import { DeliveryNotesPDFModalComponent } from './delivery-notes-page/delivery-notes/delivery-notes-pdf-modal/delivery-notes-pdf-modal.component';
import { DeliveryNotesComponent } from './delivery-notes-page/delivery-notes/delivery-notes.component';
import { DeliveryNotesService } from './delivery-notes-page/delivery-notes/delivery-notes.service';
import { TaskRequestsService } from './task-requests-page/task-requests/task-requests.service';
import { ProjectsDetailComponent } from './projects-page/projects/projects-detail/projects-detail.component';
import { ProjectsHttpService } from './projects-page/projects/projects-http.service';
import { ProjectsModalComponent } from './projects-page/projects/projects-modal/projects-modal.component';
import { ProjectsComponent } from './projects-page/projects/projects.component';
import { ProjectsService } from './projects-page/projects/projects.service';
import { ReportService } from './reports-page/reports/report.service';
import { ReportTimeTrackClientComponent } from './reports-page/reports/time-track-client/time-track-client-report.component';
import { ReportTimeTrackWorkerComponent } from './reports-page/reports/time-track-worker/time-track-worker-report.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { TooltipComponent } from './calendar-page/calendar-old/tooltip-component/tooltip.component';
import { VendorsComponent } from './vendors-page/vendors/vendors.component';
import { VendorsService } from './vendors-page/vendors/vendors.service';
import { VendorsModalComponent } from './vendors-page/vendors/vendors-modal/vendors-modal.component';
import { ExpensesReportService } from './expenses-report-page/expenses-report/expenses-report.service';
import { ExpensesreportComponent } from './expenses-report-page/expenses-report/expenses-report.component';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { FullCalendarModule } from '@fullcalendar/angular';
import { DashBoardService } from './dashboard-page/dashboard/dashboard.service';
import { DashboardHttpService } from './dashboard-page/dashboard/dashboard-http.service';

/*
const config: InputFileConfig = {
  fileAccept: '*',
  fileLimit: 4
};
*/

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FileUploadModule,
    SharedModule,
    MaterialModule,
    DxSchedulerModule,
    DxTemplateModule,
    DxAutocompleteModule,
    DxTextBoxModule,
    DxColorBoxModule,
    DxButtonModule,
    DxPopupModule,
    DxLoadPanelModule,
    DxDataGridModule,
    DxSliderModule,
    DxLinearGaugeModule,
    DxPieChartModule,
    DxChartModule,
    DxGanttModule,
    // InputFileModule.forRoot(config),
    NgxExtendedPdfViewerModule,
    GoogleMapsModule,
    FullCalendarModule
  ],
  declarations: [
    TaskComponent,
    TaskListComponent,
    TaskModalComponent,
    MatchClientModalComponent,
    TaskGroupComponent,
    NextAppointmentModalComponent,
    TaskSingleComponent,
    TaskModalProductsComponent, //ADVERTENCIA grandes cambios para no saltar error al migrar 
    TaskBoardComponent,
    TaskCommentComponent, //app file uploader error
    TaskCommentsComponent,
    TaskMovementsComponent,
    TaskWorkerWhappSelComponent,
    TaskClientAddressSelComponent,
    TaskScheduleComponent,
    TaskShareComponent,
    UsersComponent,
    UsersModalComponent,
    RolesComponent,
    RolesModalComponent,
    ProductsComponent,
    ProductsModalComponent,
    CategoriesComponent,
    CategoriesModalComponent,
    CurrenciesComponent,
    CurrenciesModalComponent,
    CountriesComponent,
    CountriesModalComponent,
    CountersModalComponent,
    CompaniesComponent,
    CompaniesModalComponent,
    CompaniesStatsComponent,
    WorkersComponent,
    WorkersModalComponent,
    ClientsComponent,
    AgentsComponent,
    AgentsModalComponent,
    TaskRequestsComponent,
    TaskRequestsDetailComponent, //app file uploader error
    ClientsModalComponent,
    AccountComponent,
    PasswordModalComponent,
    DashboardComponent,
    CalendarComponent, // problema con libreria
    FeaturesComponent,
    FeaturesModalComponent,
    SettingsComponent,
    SettingsModalComponent,
    SettingsCompanyComponent,
    SettingsCompanyModalComponent,
    SubscriptionsComponent,
    SubscriptionsModalComponent,
    FileUploaderComponent, 
    TimeTrackComponent,
    TimeTrackModalComponent,
    TaskSearchComponent,
    CalendarByWorkerComponent,
    CalendarByClientComponent,
    ExternalRequestModalComponent,
    BillingDocumentsComponent,
    BillingDocumentsModalComponent,
    BillingDocumentsPDFModalComponent,
    BillingDocumentsBulkModalComponent,// file uploader error
    CorrectiveInvoiceModalComponent,
    ReportTimeTrackClientComponent,
    ReportTimeTrackWorkerComponent,
    // CreateModalComponent,
    QuotesComponent,
    AgreementsComponent,
    QuotesModalComponent,
    QuotesPDFModalComponent, // problema con ngx
    LoggerComponent,
    ChangeLogComponent,
    DeliveryNotesComponent,
    DeliveryNotesPDFModalComponent, // problema con ngx
    DeleteTasksDialogComponent,
    ProjectsComponent,
    ProjectsModalComponent,
    ProjectsDetailComponent, // file uploader error
    ExpensesComponent,
    ExpensesModalComponent,
    DetailItemExpensesComponent,
    DetailListExpensesComponent,
    ExpensesreportComponent,
    TooltipComponent,
    VendorsComponent,
    VendorsModalComponent
  ],
  exports: [
    TaskComponent,
    TaskListComponent,
    TaskModalComponent,
    MatchClientModalComponent,
    TaskGroupComponent,
    NextAppointmentModalComponent,
    TaskSingleComponent,
    TaskModalProductsComponent,
    TaskBoardComponent,
    TaskCommentComponent,
    TaskCommentsComponent,
    TaskMovementsComponent,
    TaskWorkerWhappSelComponent,
    TaskClientAddressSelComponent,
    TaskScheduleComponent,
    TaskShareComponent,
    UsersComponent,
    UsersModalComponent,
    RolesComponent,
    RolesModalComponent,
    ProductsComponent,
    ProductsModalComponent,
    CategoriesComponent,
    CategoriesModalComponent,
    CurrenciesComponent,
    CurrenciesModalComponent,
    CountriesComponent,
    CountriesModalComponent,
    CountersModalComponent,
    CompaniesComponent,
    CompaniesModalComponent,
    CompaniesStatsComponent,
    WorkersComponent,
    WorkersModalComponent,
    ClientsComponent,
    AgentsComponent,
    AgentsModalComponent,
    TaskRequestsComponent,
    TaskRequestsDetailComponent,
    ClientsModalComponent,
    AccountComponent,
    PasswordModalComponent,
    DashboardComponent,
    CalendarComponent,
    FeaturesComponent,
    FeaturesModalComponent,
    SettingsComponent,
    SettingsModalComponent,
    SettingsCompanyComponent,
    SettingsCompanyModalComponent,
    SubscriptionsComponent,
    SubscriptionsModalComponent,
    FileUploaderComponent,
    TimeTrackComponent,
    TimeTrackModalComponent,
    TaskSearchComponent,
    CalendarByWorkerComponent,
    CalendarByClientComponent,
    ExternalRequestModalComponent,
    BillingDocumentsComponent,
    BillingDocumentsModalComponent,
    BillingDocumentsPDFModalComponent,
    BillingDocumentsBulkModalComponent,
    CorrectiveInvoiceModalComponent,
    ReportTimeTrackClientComponent,
    ReportTimeTrackWorkerComponent,
    // CreateModalComponent,
    QuotesComponent,
    AgreementsComponent,
    QuotesModalComponent,
    QuotesPDFModalComponent,
    LoggerComponent,
    ChangeLogComponent,
    DeliveryNotesComponent,
    DeliveryNotesPDFModalComponent,
    DeleteTasksDialogComponent,
    ProjectsComponent,
    ProjectsModalComponent,
    ProjectsDetailComponent,
    ExpensesComponent,
    ExpensesModalComponent,
    DetailItemExpensesComponent,
    DetailListExpensesComponent,
    ExpensesreportComponent,
    TooltipComponent,
    VendorsComponent,
    VendorsModalComponent
  ],
  providers: [
    TaskService,
    TaskHttpService,
    TaskCommentService,
    TaskShareService,
    UserService,
    RolesService,
    ProductsService,
    CategoriesService,
    CurrenciesService,
    CountriesService,
    CountersService,
    CompaniesService,
    WorkersService,
    ClientsService,
    AgentsService,
    TaskRequestsService,
    CountersService,
    FeaturesService,
    SettingsService,
    SubscriptionsService,
    AppointmentsService,
    FileService,
    TimeTrackService,
    ExternalRequestService,
    ReportService,
    BillingDocumentService,
    CorrectiveInvoiceService,
    // DashBoardService,
    QuotesService,
    QuotesHttpService,
    ServiceAgreementHttpService,
    LoggerService,
    DeliveryNotesService,
    // NotificationsService,
    ProjectsService,
    ProjectsHttpService,
    DashBoardService,
    DashboardHttpService,
    ExpensesService,
    ExpensesReportService,
    VendorsService,
  ],
})

export class AdminModule { }
